export default __webpack_public_path__ + "static/media/close.b0177afe.svg";